export default __webpack_public_path__ + "static/media/cavinimg.d25272c6.jpg";